import { AuthenticationError, GraphQLErrorCode } from './types';

// for unexpected graph behaviour, we can logout
export const isGraphQLAuthError = (error: any) => {
  if (error && error.graphQLErrors && error.graphQLErrors.length) {
    return Boolean(
      error.graphQLErrors.find(
        (err: {
          extensions: {
            code: string;
          };
        }) =>
          err.extensions &&
          err.extensions.code === GraphQLErrorCode.UNAUTHENTICATED,
      ),
    );
  }
  return false;
};

export const handleAuthError = (error: any) => {
  if (isGraphQLAuthError(error)) {
    throw new AuthenticationError();
  }

  throw error;
};

export const handleValidationErrors = (error: any) => {
  // eslint-disable-next-line no-console
  console.log({
    validationError: error,
    validationErrorString: JSON.stringify(error, null, 2),
  });

  throw error;
};
